module.exports = __webpack_public_path__ + "static/media/241.88e22863.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/241.jpg
// module id = 964
// module chunks = 0